import React, {useState} from 'react'
import axios from "axios";
import {Button, Col, Container, Form, InputGroup, Row, Table} from "react-bootstrap";
import './ReporteProductos.css';
import {Search} from "@carbon/icons-react";

const ReporteProductos = () => {

    const [productReport, setProductReport] = useState([]);
    const [dateFrom, setDateFrom] = useState();
    const [dateTo, setDateTo] = useState();
    const [isDateFromInvalid, setIsDateFromInvalid] = useState(false);
    const [isDateToInvalid, setIsDateToInvalid] = useState(false);

    const keyLocalStorage = 'authToken';
    const getConfig = () => {
        return {
            withCredentials: true,
            headers: {
                Authorization: localStorage.getItem(keyLocalStorage),
            },
            params: {
                fromDate: dateFrom,
                toDate: dateTo
            }
        }
    }

    const getAllMostSelledProducts = () => {

        if(!dateFrom && !dateTo) {
            setIsDateFromInvalid(true);
            setIsDateToInvalid(true);
        } else {
            axios.get(process.env.REACT_APP_API_REPORTE_PRODUCTOS_ROUTE, getConfig())
                .then((response) => {
                    setProductReport(response.data.reportMostSelledProductsDetailsDTO);
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    }

    const handleDateChange = (e) => {
        const { name, value } = e.target;
        if (name === 'dateFrom') {
            setDateFrom(value);
            setIsDateFromInvalid(false);
        } else if (name === 'dateTo') {
            setDateTo(value);
            setIsDateToInvalid(false);
        }
    };

    return (
        <div className="reporteProductosContainer">
            <Container className="mt-3 mb-3">
                <Row>
                    <Col>
                        <h1 className="titleReporteProductos">Reporte de productos mas vendidos</h1>
                    </Col>
                </Row>
            </Container>
            <Container>
                <Row>
                    <Col xs={5}>
                        <InputGroup className="mb-3">
                            <InputGroup.Text>Fecha Desde</InputGroup.Text>
                            <Form.Control
                                aria-label="dateFrom"
                                type="date"
                                name="dateFrom"
                                value={dateFrom}
                                onChange={handleDateChange}
                                isInvalid={isDateFromInvalid}
                            />
                        </InputGroup>
                    </Col>
                    <Col xs={5}>
                        <InputGroup className="mb-3">
                            <InputGroup.Text>Fecha Hasta</InputGroup.Text>
                            <Form.Control
                                aria-label="dateTo"
                                type="date"
                                name="dateTo"
                                value={dateTo}
                                onChange={handleDateChange}
                                isInvalid={isDateToInvalid}
                            />
                        </InputGroup>
                    </Col>
                    <Col xs={1}>
                        <Button className="me-1" variant="primary" onClick={() => getAllMostSelledProducts()}>
                            <Search/>
                        </Button>
                    </Col>
                </Row>
            </Container>
            <Container fluid>
                <Row>
                    <Col>
                        <Table responsive className="table-striped">
                            <thead>
                            <tr>
                                <th style={{
                                    backgroundColor: "rgb(235, 120, 107)",
                                    color: "#ffffff"
                                }}>Ranking</th>
                                <th style={{
                                    backgroundColor: "rgb(235, 120, 107)",
                                    color: "#ffffff"
                                }}>ID de producto</th>
                                <th style={{
                                    backgroundColor: "rgb(235, 120, 107)",
                                    color: "#ffffff"
                                }}>Nombre de producto</th>
                                <th style={{
                                    backgroundColor: "rgb(235, 120, 107)",
                                    color: "#ffffff"
                                }}>Marca</th>
                                <th style={{
                                    backgroundColor: "rgb(235, 120, 107)",
                                    color: "#ffffff"
                                }}>Cantidad vendida</th>
                                <th style={{
                                    backgroundColor: "rgb(235, 120, 107)",
                                    color: "#ffffff"
                                }}>Sucursal</th>
                            </tr>
                            </thead>
                            <tbody>
                            {   productReport.length === 0 ? (
                                <tr>
                                    <td colSpan="6" className="text-center">Por favor ingrese un filtro</td>
                                </tr>
                            ) : (
                                productReport.map((product, index) => (
                                    <tr key={product.productId}>
                                        <td>{index + 1}</td>
                                        <td>{product.productId}</td>
                                        <td>{product.product}</td>
                                        <td>{product.brandName}</td>
                                        <td>{product.quantity}</td>
                                        <td>{product.shopBranchName}</td>
                                    </tr>
                                )))
                            }
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Container>
        </div>
    )

}

export default ReporteProductos;